import { render, staticRenderFns } from "./ClientesCadastroForm.vue?vue&type=template&id=6d3889e2&scoped=true&"
import script from "./ClientesCadastroForm.vue?vue&type=script&lang=js&"
export * from "./ClientesCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientesCadastroForm.vue?vue&type=style&index=0&id=6d3889e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3889e2",
  null
  
)

export default component.exports